function formatScoreValue(score: number): string {
  return String(score).replace('.', ',')
}

export function formatScore(score: number | null | undefined): string {
  if (score === null || score === undefined) return '—'
  return `${formatScoreValue(score)}/10`
}

export function formatAverageScore(score: number | null | undefined): string {
  if (score === null || score === undefined) return '—'
  return `${formatScoreValue(score)} / 10`
}
